export type VisitLocationState = {
  source?: string;
  from?: string;
  patientId?: number;
};

/**
 * The result is rendered as `<Link to={backTo}>`, so a protocol-relative value
 * like `//evil.example` would become a literal cross-origin `href`. No caller
 * passes untrusted input today, but `location.state` is never validated at a
 * trust boundary, so the guard stays here where the value becomes a URL.
 */
function isSafeInternalPath(path: string): boolean {
  if (!path.startsWith("/")) return false;
  if (path.startsWith("//")) return false;
  return true;
}

/**
 * Resolve where Back should go from the visit route.
 * Prefer explicit `from` provenance when it is a same-app path, else fallback.
 *
 * Callers must navigate with `replace` so the visit entry is removed from
 * history; otherwise Past Visits Back (`navigate(-1)`) returns to the visit
 * and loops.
 */
export function resolveVisitBackTarget(input: {
  state: VisitLocationState | null | undefined;
  fallbackPath: string;
}): string {
  const from = input.state?.from?.trim();
  if (from && isSafeInternalPath(from)) return from;
  return input.fallbackPath;
}
